import { Component, OnInit } from '@angular/core';
import { PointsService } from 'src/app/services/points.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { GlobalSelectionControlService } from '../services/global-selection-control.service';
import { EventListenersOnMap } from 'src/app/utils/eventListenersOnMap';
import { IdentifyToolService } from 'src/app/services/identify-tool.service';
import { SelectByFirComponent } from 'src/app/popup/select-by-fir/select-by-fir.component';
import { TerrainHeightService } from '../services/terrain-height.service';
import { DistanceAzimuthService } from '../services/distance-azimuth.service';
import { TerrainAltitudeCutService } from 'src/app/services/terrain-altitude-cut.service';

@Component({
  selector: 'app-global-selection',
  templateUrl: './global-selection.component.html',
  styleUrls: ['./global-selection.component.scss'],
  standalone: false
})
export class GlobalSelectionComponent implements OnInit {

  constructor(public globalSelectionService : GlobalSelectionControlService,
    public toolsService : ToolsControlService,
    public pointsService : PointsService) { }

  ngOnInit(): void {
  }

  displayCloseEventsButton(): boolean {
    return (
      EventListenersOnMap.hasEvent(IdentifyToolService.EVENT_ON_MAP_LABEL) ||
      EventListenersOnMap.hasEvent(SelectByFirComponent.EVENT_ON_MAP_LABEL) ||
      EventListenersOnMap.hasEvent(TerrainHeightService.EVENT_ON_MAP_LABEL) ||
      EventListenersOnMap.hasEvent(DistanceAzimuthService.EVENT_ON_MAP_LABEL) ||
      EventListenersOnMap.hasEvent(TerrainAltitudeCutService.EVENT_ON_MAP_LABEL)
    );
  }

  getActiveEvent(): string {
    return EventListenersOnMap.getActiveExclusiveEvent();
  }

}
